import React from 'react';
import { FieldPath, FieldValues, useFormContext, useWatch } from 'react-hook-form';

type WatchFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends keyof TFieldValues = keyof TFieldValues,
> = {
  name: TName;
  children: (value: TFieldValues[TName]) => React.ReactNode;
};

/**
 * A declarative way to watch a form field value inside JSX.
 * Usage: <WatchField name="fieldName">{value => (...)}</WatchField>
 */
export function WatchField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, children }: WatchFieldProps<TFieldValues, TName>): JSX.Element {
  const { control } = useFormContext<TFieldValues>();
  const value = useWatch<TFieldValues, TName>({ control, name });
  return <>{children(value)}</>;
}
